import styled from 'styled-components';

const SlackChannelError = styled.span`
  color: #e74c3c;
  display: block;
  font-size: 12px;
  margin-top: 6px;
`;

export default SlackChannelError;
